import CONSTANTS from "@components/FallRegistration/utils/constants";
export default {
	title: "Premium education for developing leaders",
	sections: [
		{
			items: [
				{ text: "Store Home", link: "/store" },
				{ text: "All Courses", link: "/education/courses" },
				// { text: "Leadership Basics & Early Career", link: "/education/courses/basic" },
				// {
				// 	text: "Advanced & C-Level",

				// 	link: "/education/courses/advanced",
				// },
				// {
				// 	text: "Shop Leadership Assessment recommended courses ",
				// 	icon: "colorGradient",
				// 	iconClass: "d-none  d-lg-inline-block border",
				// 	iconStyle: { position: "absolute", left: "-10px", top: 0 },
				// 	link: "/",
				// },
				{
					text: "CPE Core",
					link: "/education/courses/cpe-core",
				},
				{
					text: "CPE Electives",
					link: "/education/courses/cpe-elective",
				},
				{
					text: "Masters Core",
					link: "/education/courses/masters",
				},
				{
					text: "Online",
					link: "/education/courses/online",
				},
				{
					text: "Hybrid Online",
					link: "/education/courses/hybrid-online",
				},
				{
					text: "In-Person",
					link: "/education/courses/in-person",
				},
			],
		},

		{
			items: [
				{
					text: "Books",
					link: "/publications/books",
				},
				{
					text: "Join Membership",
					link: `${process.env.APP_URL}/membership/join`,
				},
				{
					text: "Renew Membership",
					link: "/membership",
				},
				{
					text: "Leadership Assessment",
					link: "/assessment",
				},
				{
					text: "Technical Skills Assessment",
					link: "/assessment/technical-skills",
				},
			],
		},
	],

	side: {
		title: "UPCOMING EVENTS",
		data: [
			{
				subTitle: `${CONSTANTS.FALL_YEAR} AAPL Fall Institute`,
				dateLocation: `${CONSTANTS.FALL_DATES}, ${CONSTANTS.FALL_YEAR} in Scottsdale, Arizona`,
				link: "/fall-institute",
			},
			{
				subTitle: "2026 Annual Leadership Conference",
				dateLocation: "October, 22-25 2026 in Scottsdale, Arizona",
				link: "/conference",
			},
		],
	},
};
